<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" xl="6">
        <b-card :header="$t('Third Party Player')" style="position:relative">
          <b-form @submit.prevent="onSubmitDetails" autocomplete="off" ref="cnt">

            <FloatingLabel v-model="details.tenant_id.brand_name" label="Tenant" size="sm" :readonly="true" />

            <multiselect
              v-model="details.shop_id"
              :options="shopList"
              placeholder="No shop assigned to third party player"
              track-by="name"
              label="name"
              :translate="false"
            ></multiselect>

            <FloatingLabel v-model="details.name" label="Name" size="sm" :readonly="true" />
            <FloatingLabel v-model="details.surname" label="Surname" size="sm" :readonly="true" />

            <FloatingLabel v-model="details.email" label="Email" type="email" size="sm" :readonly="true" />
            <FloatingLabel v-model="details.external_id" label="External ID" size="sm" :readonly="true" />

            <!--
            <FloatingLabel
              v-model="details.cnp"
              label="CNP"
              :state="isCNPValid"
              size="sm"
              aria-describedby="input-live-feedback"
            >
              <template v-slot:feedback>
                <div id="input-live-feedback" class="invalid-feedback">{{$t('Invalid CNP')}}</div>
              </template>
            </FloatingLabel>
            -->

            <!--
            <b-form-group :label="$t('Blacklist this third party player')" class="grouping py-2 px-3 mb-3 mt-0">
              <b-form-checkbox
                v-model="details.blacklisted"
                :value="true"
                :unchecked-value="false"
              >{{$t('Blacklisted')}}</b-form-checkbox>
            </b-form-group>
            -->

            <div style="text-align:right">
              <b-button type="submit" variant="success">{{$t('Save')}}</b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import FloatingLabel from "@/components/FloatingLabel";
import { successConf, errorConf } from "@/shared/notifications";
// import validCNP from "@/shared/cnp";
import Multiselect from "@/components/multiselect-filters";

export default {
  name: "thirdPartyPlayer",
  props: ["selectedeid"],
  components: {
    FloatingLabel,
    Multiselect,
  },

  mounted() {
    this.eid = this.$route.params.id != "0" ? this.$route.params.id : "";

    if (this.selectedeid) {
      this.eid = this.selectedeid;
    } else if (!this.eid) {
      this.eid = "";
    }

    if (this.eid != "0" && this.eid != "") {

    Promise.all([
      this.$store.dispatch("cache/fetch", "shops").catch(err => {}),
      this.$store.dispatch("cache/fetch", "tenants").catch(err => {}),
    ]).finally(() => {
        this.loadData();
      });

      /*
    } else {
      this.newId = true;
      */
    }
  },

  data: function() {
    return {
      eid: "",
      details: {
        tenant_id: {},
        shop_id: {},
        name: "",
        surname: "",
        // cnp: "",
        // blacklisted: false,
        email: "",
        external_id: "",
      },
      // newId: false,
      // temp: {}, // ? WHY ?
      // isCNPValid: null
    };
  },
  /*
  watch: {
    "details.cnp": function(newVal) {
      this.isCNPValid = false;
      if (validCNP(newVal)) {
        this.isCNPValid = true;
      }
    }
  },
  */

  computed: {
    tenantsList() {
      const list = this.$store.getters["cache/tenants"];
      return list ? list : [];
    },
    shopList() {
      const self = this;
      const list = this.$store.getters["cache/shops"];

      const tmp = [];
      if (this.details.tenant_id) {
        list.forEach(item => {
          if (item.etenant_id == self.details.tenant_id.eid) {
            tmp.push(item);
          }
        });
      }

      return tmp;
    },
  },

  methods: {

    loadData() {
      if (this.eid == "") return;

      const loader = this.$loading.open({
        container: this.$refs.cnt
      });

      this.$store
        .dispatch("thirdPartyPlayer/read", this.eid)
        .then(resp => {
          // this.temp = resp.data; // ? WHY ?
          this.populateData(resp.data);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loader.close();
        });
    },

    onSubmitDetails() {
      const loader = this.$loading.open({
        container: this.$refs.cnt
      });

      const detailsData = JSON.parse(JSON.stringify(this.details));

      // this condition maintained for consistency only
      // field is read-only and therefore always returns the same data
      if (detailsData.tenant_id && detailsData.tenant_id.eid) {
        detailsData.etenant_id = detailsData.tenant_id.eid
      } else {
        detailsData.etenant_id = null; // this should never happen (tenant mandatory for 3rdPP)
      }
      delete detailsData.tenant_id;

      if (detailsData.shop_id && detailsData.shop_id.eid) {
        detailsData.eshop_id = detailsData.shop_id.eid
      } else {
        detailsData.eshop_id = null;
      }
      delete detailsData.shop_id;

      let apiAction = "thirdPartyPlayer/update";
      /*
      if (this.newId) {
        apiAction = "thirdPartyPlayers/create";
      } else {
      */
        detailsData.eid = this.eid;
      // }

      this.$store
        .dispatch(apiAction, detailsData)
        .then(resp => {
          let msg = "Third party player updated";
          /*
          if (this.newId && resp.data.id) {
            this.updateId(resp.data.id);
            msg = "Third party player created";
          }
          */
          this.showSuccessNotification(msg);
        })
        .catch(err => {
          this.showErrorNotification(err);
        })
        .finally(() => {
          loader.close();
        });
    },

    populateData(r) {
      // console.log("populating data:", r); // debug only
      if (typeof r == "undefined") return;
      this.eid = typeof r.eid != "undefined" ? r.eid : "";

      // this.details.tenant_id = r.etenant_id
      this.details.tenant_id = r.etenant_id ? r.etenant_id : "zDVVI_Pw3pVmr0tYzBI-vw"; // DEBUG ONLY use "Test2" tenant eid
      this.details.shop_id = r.eshop_id;
      this.details.name = r.name;
      this.details.surname = r.surname;
      /*
      this.details.cnp = r.cnp;
      if (typeof r.blacklisted != "undefined") {
        this.details.blacklisted = r.blacklisted;
      }
      */
      this.details.email = r.email;
      this.details.external_id = r.external_id;

      if (this.details.tenant_id) {
        this.tenantsList.forEach(element => {
          if (element.eid == this.details.tenant_id) {
            this.details.tenant_id = element;
            return;
          }
        });
      }

      if (this.details.shop_id) {
        this.shopList.forEach(element => {
          if (element.eid == this.details.shop_id) {
            this.details.shop_id = element;
            return;
          }
        });
      }

    },
    /*
    updateId(id) {
      this.eid = id;
      this.newId = false;
      this.$router.replace({ name: "ThirdPartyPlayer", params: { id: id } });
    },
    */

    showErrorNotification(err) {
      if (err.details && err.details.length) {
        this.$bvToast.toast(
          this.$t(err.details[0]),
          errorConf(this.$t("Error"))
        );
      } else {
        this.$bvToast.toast(this.$t(err.message), errorConf(this.$t("Error")));
      }
    },

    showSuccessNotification(msg) {
      this.$bvToast.toast(this.$t(msg), successConf(this.$t("Success")));
    },

  }
};
</script>

<style lang="scss" scoped>
</style>
